module.exports = __webpack_public_path__ + "img/24-girl.c7a9ccd1.svg";